import type L from "leaflet";
import type React from "react";
import { createContext, useContext, useRef, type ReactNode } from "react";

interface MapStateContextType {
  mapInstance: React.MutableRefObject<L.Map | null>;
  shouldPreserveMapState: React.MutableRefObject<boolean>;
}

const MapStateContext = createContext<MapStateContextType | undefined>(
  undefined,
);

export const MapStateProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  // Use refs instead of state to avoid re-renders
  const mapInstance = useRef<L.Map | null>(null);
  const shouldPreserveMapState = useRef<boolean>(false);

  return (
    <MapStateContext.Provider value={{ mapInstance, shouldPreserveMapState }}>
      {children}
    </MapStateContext.Provider>
  );
};

export const useMapState = () => {
  const context = useContext(MapStateContext);
  if (context === undefined) {
    throw new Error("useMapState must be used within a MapStateProvider");
  }
  return context;
};
